{
  "info": "Примечание",
  "tip": "Совет",
  "warning": "Важно",
  "alert": "Внимание",
  "remove": "Удалить"
}
